import { selexpConParApiDuck } from '../selexp-conpar-api-duck';
import { TAppConfig } from './types-app-config';

export const appConfigApiDuck = selexpConParApiDuck.injectEndpoints({
  endpoints: (builder) => ({
    getAppConfig: builder.query<TAppConfig, string>({
      query: () => ({
        url: '/AppConfiguration/GetAppConfiguration',
        noFilters: true,
        headers: {
          'Cache-Control': 'no-cache no-store',
        },
      }),
      transformResponse: (response: TAppConfig) => ({
        ...response,
        defaultFiscalYearId: response.defaultFiscalYearId,
        defaultSemesterId: response.defaultSemesterId,
      }),
    }),
  }),
});

export const { useGetAppConfigQuery } = appConfigApiDuck;
